import React from 'react';
import { ListsPage } from '@/components/lists/ListsPage';
import { usePageTitle } from '@/hooks/usePageTitle';

const Lists: React.FC = () => {
	usePageTitle("Lists");
	return <ListsPage />;
};

export default Lists;
